export function completeObject(targetObj, baseObj) {
    const merge = (target, base) => {
        const t = target;
        const baseType = Object.prototype.toString.call(base);
        if (baseType === '[object Object]') {
            Object.keys(base).forEach((name) => {
                if (!Object.prototype.hasOwnProperty.call(t, name)) {
                    if (Object.prototype.toString.call(base[name]) === '[object Object]') {
                        t[name] = {};
                    }
                    else if (Object.prototype.toString.call(base[name]) === '[object Array]') {
                        t[name] = [];
                    }
                    else {
                        t[name] = base[name];
                    }
                }
                merge(t[name], base[name]);
            });
        }
        else if (baseType === '[object Array]') {
            if (t.length < base.length) {
                for (let i = t.length; i < base.length; i += 1) {
                    const subBaseType = Object.prototype.toString.call(base[i]);
                    if (subBaseType === '[object Object]') {
                        t[i] = {};
                        merge(t[i], base[i]);
                    }
                    else if (subBaseType === '[object Array]') {
                        t[i] = [];
                        merge(t[i], base[i]);
                    }
                    else {
                        t[i] = base[i];
                    }
                }
            }
        }
    };
    merge(targetObj, baseObj);
    return targetObj;
}
